import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="M88.7 27.44a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M12.623 79.503l3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12z"
    />
    <path fill="#ACB8C3" d="M27.6 91.08a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#C7D0D9"
      d="M83.64 9.07h-5.57V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H69.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M42 112c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M98.04 100.289c-1.09 0-2.18-.42-3-1.25L76.36 80.36a4.249 4.249 0 1 1 6.01-6.01l18.68 18.68a4.25 4.25 0 0 1 0 6.01c-.83.83-1.92 1.25-3 1.25z"
    />
    <path
      fill="#C7D0D9"
      d="M56.51 86.8c17.905 0 32.42-14.515 32.42-32.42S74.415 21.96 56.51 21.96 24.09 36.475 24.09 54.38 38.605 86.8 56.51 86.8"
    />
    <path
      fill="#8F9BA8"
      d="M56.51 79.69c13.978 0 25.31-11.331 25.31-25.31S70.488 29.07 56.51 29.07 31.2 40.402 31.2 54.38c0 13.979 11.332 25.31 25.31 25.31"
    />
    <path
      fill="#fff"
      d="M71.76 48.4c-.8 0-1.57-.43-1.98-1.18a15.07 15.07 0 0 0-13.27-7.91c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25c7.2 0 13.8 3.94 17.22 10.27.59 1.09.18 2.46-.91 3.05-.34.18-.71.27-1.07.27z"
    />
  </svg>
);
const SvgEnrichedIconSearchGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconSearchGreyscale);
export default Memo;
